'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shouldDisplayAsSent = undefined;

var _messageTypeComparators = require('../../pubnub-message/operators/messageTypeComparators');

var _isPublished = require('../../pubnub-message/operators/isPublished');

var _isScheduled = require('../../pubnub-message/operators/isScheduled');

var _isSimulated = require('../../pubnub-message/operators/isSimulated');

var shouldDisplayAsSent = exports.shouldDisplayAsSent = function shouldDisplayAsSent(message) {
  return (0, _messageTypeComparators.isOfflineMessage)(message) || (0, _isPublished.isPublished)(message) || (0, _isScheduled.isScheduled)(message) || (0, _isSimulated.isSimulated)(message) || (0, _messageTypeComparators.isAutomatedChatMessage)(message);
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/chat-message/operators/shouldDisplayAsSent.js
// module id = 1130
// module chunks = 2 3